import styled from 'styled-components'

export const cardWithBackgroundStyle: React.CSSProperties = {
  border: 'none',
  borderRadius: ' 6px',
  background: '#F8F9FB',
  marginBottom: '12px',
  padding: '12px',
  transition: 'all 0.3s ease-in-out'
}

export const cardStyle: React.CSSProperties = {
  border: 'none',
  marginBottom: '12px',
  transition: 'all 0.3s ease-in-out'
}

export const cardBodyStyle: React.CSSProperties = {
  padding: '0',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '2px',
  alignSelf: 'stretch'
}

export const titleStyle: React.CSSProperties = {
  color: 'rgba(0, 0, 0, 0.45)',
  fontSize: '14px',
  fontStyle: 'normal',
  fontWeight: 400,
  lineHeight: '22px',
  transition: 'all 0.3s ease-in-out'
}

export const iconCheckStyle: React.CSSProperties = {
  color: '#52c41a',
  marginRight: 8,
  transition: 'color 0.3s ease-in-out'
}

export const iconCloseStyle: React.CSSProperties = {
  marginRight: 8,
  transition: 'color 0.3s ease-in-out'
}

export const Container = styled.div`
  display: 'flex';
  align-items: 'center';
`

export const ContainerHeader = styled.div<{ showDetailedView?: boolean }>`
  opacity: ${(props) => (props.showDetailedView ? 1 : 0)};
  max-height: ${(props) => (props.showDetailedView ? '50px' : '0px')};
  overflow: hidden;
  transition: all 0.3s ease-in-out;
  width: 100%;
`
